import { SelectChangeEvent } from '@mui/material'
import { ChangeEvent, useState } from 'react'
import { useSelector } from 'react-redux'
import { formValidator } from '../../../../../redux/actions/validator'
import { IRootState } from '../../../../../redux/types'
import { IContactUs } from '../../models/helpcenter'

type FormElement = ChangeEvent<HTMLInputElement>

export const useContactForm = (t: any, dispatch: any) => {
  const { errorForm, msgForm } = useSelector((state: IRootState) => state.validator)

  const topics = [
    { id: 1, name: t('contactUs.topics.topic-1') },
    { id: 2, name: t('contactUs.topics.topic-2') },
    { id: 3, name: t('contactUs.topics.topic-3') }
  ]

  const [contactUs, setContactUs] = useState<IContactUs>({
    topic: null,
    email: '',
    name: '',
    subject: '',
    message: '',
    filesName: []
  })

  const handleSelectChange = (event: SelectChangeEvent<unknown>) => {
    setContactUs({ ...contactUs, topic: event.target.value as number })
  }

  const handleInputChange = (inputName: string) => (event: FormElement) => {
    const value = event.target.value
    setContactUs({ ...contactUs, [inputName]: value })
  }

  const getUploadParams = ({ meta }: any) => {
    let tmpFileNames = [...contactUs.filesName]
    tmpFileNames.push(meta.name)
    setContactUs({ ...contactUs, filesName: tmpFileNames })
    return { url: `${import.meta.env.VITE_API_URL}/help/upload/${meta.name}` }
  }

  const handleSubmit = () => {
    dispatch(
      formValidator({
        topic: [contactUs.topic, 'required|numeric'],
        email: [contactUs.email, 'required'],
        name: [contactUs.name, 'required|min:2'],
        subject: [contactUs.subject, 'required|max:200|min:2'],
        message: [contactUs.message, 'required|min:2']
      })
    )
  }

  return {
    contactUs,
    setContactUs,
    topics,
    handleSelectChange,
    handleInputChange,
    getUploadParams,
    handleSubmit,
    errorForm,
    msgForm
  }
}
